// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/Flow.global.scss
// module id = 7bqq
// module chunks = 0